module.exports = __webpack_public_path__ + "static/media/arm-icon.9e0eed02.png";